import React, { Component } from 'react'
import SizeSelector from '../sizeSelector';
import DarkThemeNav from '../common/dark-theme-nav';

class Accordion extends Component {

  constructor(props) {
    super(props);
    this.state = {
      theme: 'default',
      size: 'medium'
    };
  }

  render (){
    const { size } = this.state;

    return(
    <section><a className="anchor" id="accordion"></a>
      <h2>Accordion</h2>
      <DarkThemeNav anchor="accordion" />
      <SizeSelector
        componentToSize={this}
      />

      <h3>Default style</h3>

      <div className="soft">
        <div className={`accordion js-accordion accordion--${ size }`}>
          <div className="accordion__item">
            <div className="accordion__title">
              <h2 className="flush">Accordion title 1</h2>
            </div>
            <div className="accordion__content">
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec et dui sit amet massa vehicula semper id eu neque. Nulla venenatis consectetur mauris. Integer eu ornare eros. In malesuada viverra urna sed vehicula.</p>
            </div>
          </div>
          <div className="accordion__item">
            <div className="accordion__title">
              <h2 className="flush">Accordion title 2</h2>
            </div>
            <div className="accordion__content">
              <p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Etiam id lorem vestibulum, ornare ipsum vel, varius magna. Integer venenatis nibh urna, et hendrerit felis venenatis in.</p>
            </div>
          </div>
          <div className="accordion__item">
            <div className="accordion__title">
              <h2 className="flush">Accordion title 3</h2>
            </div>
            <div className="accordion__content">
              <p>Curabitur accumsan augue eget purus lacinia, at fringilla velit vestibulum. Aenean iaculis enim elit. Vestibulum convallis, massa et vestibulum feugiat, leo ipsum commodo libero, vel lacinia diam libero vel purus.</p>
            </div>
          </div>
        </div>
      </div>
      <br/>
        <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
        <pre className="hide-code">
          <code className="language-html">{`
            <div class="soft">
              <div class="accordion js-accordion accordion--${size}">
                <div class="accordion__item">
                  <div class="accordion__title">
                    <h2 class="flush">Accordion title 1</h2>
                  </div>
                  <div class="accordion__content">
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec et dui sit amet massa vehicula semper id eu neque. Nulla venenatis consectetur mauris. Integer eu ornare eros. In malesuada viverra urna sed vehicula.</p>
                  </div>
                </div>
                <div class="accordion__item">
                  <div class="accordion__title">
                    <h2 class="flush">Accordion title 2</h2>
                  </div>
                  <div class="accordion__content">
                    <p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Etiam id lorem vestibulum, ornare ipsum vel, varius magna. Integer venenatis nibh urna, et hendrerit felis venenatis in.</p>
                  </div>
                </div>
                <div class="accordion__item">
                  <div class="accordion__title">
                    <h2 class="flush">Accordion title 3</h2>
                  </div>
                  <div class="accordion__content">
                    <p>Curabitur accumsan augue eget purus lacinia, at fringilla velit vestibulum. Aenean iaculis enim elit. Vestibulum convallis, massa et vestibulum feugiat, leo ipsum commodo libero, vel lacinia diam libero vel purus.</p>
                  </div>
                </div>
              </div>
            </div>`}
          </code>
        </pre>
<br/>
<h3>Light style</h3>
      <div className="soft">
        <div className={`accordion accordion--light js-accordion accordion--${ size }`}>
          <div className="accordion__item">
            <div className="accordion__title">
              <h2 className="flush">Accordion title 1</h2>
            </div>
            <div className="accordion__content">
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec et dui sit amet massa vehicula semper id eu neque. Nulla venenatis consectetur mauris. Integer eu ornare eros. In malesuada viverra urna sed vehicula.</p>
            </div>
          </div>
          <div className="accordion__item">
            <div className="accordion__title">
              <h2 className="flush">Accordion title 2</h2>
            </div>
            <div className="accordion__content">
              <p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Etiam id lorem vestibulum, ornare ipsum vel, varius magna. Integer venenatis nibh urna, et hendrerit felis venenatis in.</p>
            </div>
          </div>
          <div className="accordion__item">
            <div className="accordion__title">
              <h2 className="flush">Accordion title 3</h2>
            </div>
            <div className="accordion__content">
              <p>Curabitur accumsan augue eget purus lacinia, at fringilla velit vestibulum. Aenean iaculis enim elit. Vestibulum convallis, massa et vestibulum feugiat, leo ipsum commodo libero, vel lacinia diam libero vel purus.</p>
            </div>
          </div>
        </div>
      </div>
      <br/>
        <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
        <pre className="hide-code"><code className="language-html">{`
          <div class="soft">
            <div class="accordion accordion--light js-accordion accordion--${size}">
              <div class="accordion__item">
                <div class="accordion__title">
                  <h2 class="flush">Accordion title 1</h2>
                </div>
                <div class="accordion__content">
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec et dui sit amet massa vehicula semper id eu neque. Nulla venenatis consectetur mauris. Integer eu ornare eros. In malesuada viverra urna sed vehicula.</p>
                </div>
              </div>
              <div class="accordion__item">
                <div class="accordion__title">
                  <h2 class="flush">Accordion title 2</h2>
                </div>
                <div class="accordion__content">
                  <p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Etiam id lorem vestibulum, ornare ipsum vel, varius magna. Integer venenatis nibh urna, et hendrerit felis venenatis in.</p>
                </div>
              </div>
              <div class="accordion__item">
                <div class="accordion__title">
                  <h2 class="flush">Accordion title 3</h2>
                </div>
                <div class="accordion__content">
                  <p>Curabitur accumsan augue eget purus lacinia, at fringilla velit vestibulum. Aenean iaculis enim elit. Vestibulum convallis, massa et vestibulum feugiat, leo ipsum commodo libero, vel lacinia diam libero vel purus.</p>
                </div>
              </div>
            </div>
          </div>`}
        </code>
      </pre>
<br/>
    <h3>Highlight active style</h3>
    <div className="soft">
      <div className={`accordion accordion--highlight-active js-accordion accordion--${ size }`}>
        <div className="accordion__item">
          <div className="accordion__title">
            <h2 className="flush">Accordion title 1</h2>
          </div>
          <div className="accordion__content">
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec et dui sit amet massa vehicula semper id eu neque. Nulla venenatis consectetur mauris. Integer eu ornare eros. In malesuada viverra urna sed vehicula.</p>
          </div>
        </div>
        <div className="accordion__item">
          <div className="accordion__title">
            <h2 className="flush">Accordion title 2</h2>
          </div>
          <div className="accordion__content">
            <p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Etiam id lorem vestibulum, ornare ipsum vel, varius magna. Integer venenatis nibh urna, et hendrerit felis venenatis in.</p>
          </div>
        </div>
        <div className="accordion__item">
          <div className="accordion__title">
            <h2 className="flush">Accordion title 3</h2>
          </div>
          <div className="accordion__content">
            <p>Curabitur accumsan augue eget purus lacinia, at fringilla velit vestibulum. Aenean iaculis enim elit. Vestibulum convallis, massa et vestibulum feugiat, leo ipsum commodo libero, vel lacinia diam libero vel purus.</p>
          </div>
        </div>
      </div>
    </div>
    <br/>
      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
      <pre className="hide-code"><code className="language-html">{`
          <div class="soft">
            <div class="accordion accordion--highlight-active js-accordion accordion--${size}">
                <div class="accordion__item accordion--open">
                    <div class="accordion__title">
                        <h2 class="flush">Accordion title 1</h2>
                    </div>
                    <div class="accordion__content hard">
                        <div class="accordion accordion--light js-accordion">
                            <div class="accordion__item accordion--open">
                                <div class="accordion__title">
                                    <h2 class="flush">Accordion title 1</h2>
                                </div>
                                <div class="accordion__content">
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec et dui sit amet massa vehicula semper id eu neque. Nulla venenatis consectetur mauris. Integer eu ornare eros. In malesuada viverra urna sed vehicula.</p>
                                </div>
                            </div>
                            <div class="accordion__item">
                                <div class="accordion__title">
                                    <h2 class="flush">Accordion title 2</h2>
                                </div>
                                <div class="accordion__content">
                                    <p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Etiam id lorem vestibulum, ornare ipsum vel, varius magna. Integer venenatis nibh urna, et hendrerit felis venenatis in.</p>
                                </div>
                            </div>
                            <div class="accordion__item">
                                <div class="accordion__title">
                                    <h2 class="flush">Accordion title 3</h2>
                                </div>
                                <div class="accordion__content">
                                    <p>Curabitur accumsan augue eget purus lacinia, at fringilla velit vestibulum. Aenean iaculis enim elit. Vestibulum convallis, massa et vestibulum feugiat, leo ipsum commodo libero, vel lacinia diam libero vel purus.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="accordion__item">
                    <div class="accordion__title">
                        <h2 class="flush">Accordion title 2</h2>
                    </div>
                    <div class="accordion__content">
                        <p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Etiam id lorem vestibulum, ornare ipsum vel, varius magna. Integer venenatis nibh urna, et hendrerit felis venenatis in.</p>
                    </div>
                </div>
                <div class="accordion__item">
                    <div class="accordion__title">
                        <h2 class="flush">Accordion title 3</h2>
                    </div>
                    <div class="accordion__content">
                        <p>Curabitur accumsan augue eget purus lacinia, at fringilla velit vestibulum. Aenean iaculis enim elit. Vestibulum convallis, massa et vestibulum feugiat, leo ipsum commodo libero, vel lacinia diam libero vel purus.</p>
                    </div>
                </div>
              </div>
            </div>
      `}</code></pre>
    <br/>
    <h3>Usage</h3>
    <pre><code className="language-javascript">{`commonUI.initializeAccordion();`}</code></pre>
    <br/>
    <h3>Options</h3>
    <p>The <code>commonUI.initializeAccordion()</code> shown above will imply the default options as shown below.</p>
    <table className="table table--striped table--cosy">
      <thead>
        <tr>
          <th>Name</th>
          <th>Type</th>
          <th>Default</th>
          <th>Description</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>selector</td>
          <td>string</td>
          <td><code>'.js-accordion'</code></td>
          <td>This is the selector that will be used to hook into the DOM and Initialize the accordion.</td>
        </tr>
        <tr>
          <td>openByDefault</td>
          <td>boolean</td>
          <td><code>true</code></td>
          <td>Open the first item of the accordion on initialization.</td>
        </tr>
        <tr>
          <td>singleOpen</td>
          <td>boolean</td>
          <td><code>true</code></td>
          <td>Allow only one accordion item to be open at a time.</td>
        </tr>
      </tbody>
    </table>
    <p>These options can be overridden by passing an object to the <code>commonUI.initializeAccordion()</code> function, for example:</p>
    <pre><code className="language-javascript">{`
      commonUI.initializeAccordion({
        selector: '.js-customHookClass',
        openByDefault: false,
        singleOpen: false
      });
    `}</code></pre>

    <br/>
    <hr/>
    </section>
  )
}
}
export default Accordion



// WEBPACK FOOTER //
// ./styleguide/components/sections/Accordion.js